const HELP_CENTER_CLICKED = 'HELP_CENTER_CLICKED';

export { HELP_CENTER_CLICKED };
